import * as React from 'react';

import ExerciseFormContainer from '../../containers/ExerciseForm';
import MainMenu from '../../containers/MainMenu';
import Navbar from '../../containers/Navbar';
import i18n from '../../resources/i18n';
/**
 * 課題提出画面
 * @param props
 */
const ExerciseForm: React.FC<any> = props => {
	const careerID = props.match.params.career_id;
	const classID = props.match.params.class_id;
	const seq = props.match.params.seq;
	const flg = props.match.params.flg;
	const subjectStatusflg = props.match.params.subjectStatusflg;

	return (
		<>
			<MainMenu />
			<Navbar title={i18n.t('ExerciseForm_0014')} />
			<ExerciseFormContainer
				careerID={careerID}
				classID={classID}
				seq={seq}
				outOfPeriodFlg={false}
				preview={false}
				flg={flg}
				subjectStatusflg={subjectStatusflg}
			/>
		</>
	);
};

export default ExerciseForm;



// WEBPACK FOOTER //
// ./src/pages/personal/ExerciseForm.tsx